module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-04 (1).50da88cf.svg";